import { Stack } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useLocation } from 'react-router';
import { ENTITY_EDIT_TABS_MAP } from '../../config';
import { EntityEditTabType } from '../../@types';
import usePermissions from '../../hooks/usePermissions';
import { StyledTab, StyledTabs } from '../atoms/StyledTabs';
import TabPanel from '../atoms/TabPanel';

type EditTabsProps = {
  editEntity?: EntityEditTabType;
  selectedTab: number;
  handleTabChange: (event: React.SyntheticEvent, newTabIndex: number) => void;
};

const EditTabs = ({ children, editEntity, selectedTab, handleTabChange }: PropsWithChildren<EditTabsProps>) => {
  const location = useLocation();
  const { filterAccessibleTabs } = usePermissions();
  const currentEditEntity = editEntity || (location.pathname.split('/').pop() as EntityEditTabType);

  const currentEntityEditTabs = ENTITY_EDIT_TABS_MAP[currentEditEntity] || [];
  const accessibleTabs = filterAccessibleTabs(currentEntityEditTabs);

  return (
    <>
      <StyledTabs value={selectedTab} onChange={handleTabChange} variant='fullWidth' indicatorWidth={44}>
        <StyledTab label='Details' />
        {accessibleTabs.map((tab, index) => (
          <StyledTab key={index} label={tab.label} />
        ))}
      </StyledTabs>
      <TabPanel value={selectedTab} index={0}>
        <Stack spacing={2}>{children}</Stack>
      </TabPanel>
      {accessibleTabs.map((tab, index) => {
        return (
          <TabPanel key={index} value={selectedTab} index={index + 1}>
            <tab.component entity={currentEditEntity} />
          </TabPanel>
        );
      })}
    </>
  );
};

export default EditTabs;
